import { IconBox, type IconBoxSize } from "@hightouch/htui";

import {
  attachmentPresentation,
  type AttachmentCategory,
} from "src/components/llm/utils/attachment-presentation";

/**
 * The tinted square that says what kind of file an attachment is. Shared by the
 * composer's non-image thumbnail, the overflow list, and the sent-message chip
 * so one classification drives all three.
 *
 * Decorative: every surface that renders it also shows the filename.
 */
export const AttachmentTypeTile = ({
  category,
  size = "sm",
}: {
  category: AttachmentCategory;
  /** Figma draws the chip's tile at 20px, which is `IconBox` `sm`. */
  size?: IconBoxSize;
}) => {
  const { icon: Icon, color } = attachmentPresentation(category);

  return <IconBox icon={<Icon />} color={color} size={size} aria-hidden />;
};
